export default __webpack_public_path__ + "static/media/thumbnail.e65919a7.png";